import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';

@Injectable()
export class AppUrl {

    static get API_URL(): string {
        return environment.appUrl + 'api/';
    }

    static get APP_URL(): string {
        return environment.appUrl + 'admin/';
    }

    static get LOGIN(): string {
        return AppUrl.API_URL + 'login';
    }

    static get STUDENT_LOGIN(): string {
        return AppUrl.API_URL + 'student-login';
    }

    static get SELF(): string {
        return AppUrl.API_URL + 'self';
    }

    static LOGOUT(): string {
        return AppUrl.API_URL + 'logout';
    }

    static get VERIFY_USER(): string {
        return AppUrl.APP_URL + 'verify-user';
    }

    static UPDATE_USER_PASSWORD(): string {
        return AppUrl.API_URL + 'update-user-password';
    }

    static STATES(): string {
        return AppUrl.APP_URL + 'states';
    }

    static UNIVERSITIES(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'university/' + id;
        } else {
            return AppUrl.APP_URL + 'university';
        }
    }

    static UNIVERSITIES_LANDING(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'university-by-landing/' + id;
        } else {
            return AppUrl.APP_URL + 'university-by-landing';
        }
    }

    static UNIVERSITIES_PASSWORD(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'university-password/' + id;
        } else {
            return AppUrl.APP_URL + 'university-password';
        }
    }

    static UNIVERSITIES_COUNT(): string {
        return AppUrl.APP_URL + 'university-count';
    }

    static UNIVERSITIES_STATUS(id?): string {
        if (id) {
            return AppUrl.API_URL + 'university-setting-status/' + id;
        }
    }

    static UNIVERSITY_SETTINGS(id?): string {
        if (id) {
            return AppUrl.API_URL + 'university-setting/' + id;
        } else {
            return AppUrl.API_URL + 'university-setting';
        }
    }

    static UNIVERSITY_ACTIVE_SETTINGS_BY_LANDING(id): string {
        if (id) {
            return AppUrl.API_URL + 'university-active-setting-by-landing-page/' + id;
        }
    }

    static UNIVERSITY_SETTINGS_STATUS(id?): string {
        if (id) {
            return AppUrl.API_URL + 'university-setting-status/' + id;
        }
    }

    static PROGRAMS(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'program-by-landing-page/' + id;
        } else {
            return AppUrl.APP_URL + 'program-by-landing-page';
        }
    }

    static PROGRAMS_PASSWORD(id?): string {
        if (id) {
            return AppUrl.API_URL + 'program/' + id;
        } else {
            return AppUrl.API_URL + 'program';
        }
    }

    static PROGRAMS_STATUS(id?): string {
        if (id) {
            return AppUrl.API_URL + 'program-status/' + id;
        }
    }

    static PROGRAMS_COUNT(id?): string {
        if (id) {
            return AppUrl.API_URL + 'program-count/' + id;
        }
    }

    static COURSES(id?): string {
        if (id) {
            return AppUrl.API_URL + 'course/' + id;
        } else {
            return AppUrl.API_URL + 'course';
        }
    }

    static UNIVERSITY_COURSES(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'course/' + id;
        } else {
            return AppUrl.APP_URL + 'course';
        }
    }

    static UNIVERSITY_COURSES_LANDING(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'course-by-landing-page/' + id;
        } else {
            return AppUrl.APP_URL + 'course-by-landing-page';
        }
    }

    static COURSES_COUNT(id?): string {
        if (id) {
            return AppUrl.API_URL + 'course-count/' + id;
        }
    }

    static COURSES_STATUS(id?): string {
        if (id) {
            return AppUrl.API_URL + 'course-status/' + id;
        }
    }

    static BRANCHES(id?): string {
        if (id) {
            return AppUrl.API_URL + 'branch/' + id;
        } else {
            return AppUrl.API_URL + 'branch';
        }
    }

    static BRANCHES_COUNT(id?): string {
        if (id) {
            return AppUrl.API_URL + 'branch-count/' + id;
        }
    }

    static BRANCHES_STATUS(id?): string {
        if (id) {
            return AppUrl.API_URL + 'branch-status/' + id;
        }
    }


    static PCB_MAPPINGS(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'program-course-branch-mapping/' + id;
        } else {
            return AppUrl.APP_URL + 'program-course-branch-mapping';
        }
    }

    static PCB_MAPPINGS_BY_LANDING(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'program-course-branch-mapping-by-landing-page/' + id;
        } else {
            return AppUrl.APP_URL + 'program-course-branch-mapping-by-landing-page';
        }
    }

    static PCB_MAPPINGS_STATUS(id?): string {
        if (id) {
            return AppUrl.API_URL + 'program-course-branch-mapping-status/' + id;
        }
    }

    static PCB_MAPPINGS_COUNT(id?): string {
        if (id) {
            return AppUrl.API_URL + 'program-course-branch-mapping-count/' + id;
        }
    }

    static STUDENTS(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'student/' + id;
        } else {
            return AppUrl.APP_URL + 'student';
        }
    }

    static STUDENTS_REGISTER(): string {
        return AppUrl.API_URL + 'student-register';
    }

    static STUDENT_PASSWORD(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'student/' + id;
        } else {
            return AppUrl.APP_URL + 'student';
        }
    }

    static STUDENTS_COUNT(): string {
        return AppUrl.APP_URL + 'student-count';
    }

    static STUDENT_STATUS(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'student-status/' + id;
        }
    }

    static MAILS(id?): string {
        if (id) {
            return AppUrl.API_URL + 'mail/' + id;
        } else {
            return AppUrl.API_URL + 'mail';
        }
    }

    static MAILS_COUNT(): string {
        return AppUrl.API_URL + 'mails-count';
    }

    static FILE_UPLOAD(): string {
        return AppUrl.API_URL + 'file-upload';
    }

    static STUDENT_PERSONAL_INFO(id?): string {
        if (id) {
            return AppUrl.API_URL + 'student-personal-info/' + id;
        } else {
            return AppUrl.API_URL + 'student-personal-info';
        }
    }

    static STUDENT_ADDRESS(id?): string {
        if (id) {
            return AppUrl.API_URL + 'student-address/' + id;
        } else {
            return AppUrl.API_URL + 'student-address';
        }
    }

    static STUDENT_COURSE_DETAILS(id?): string {
        if (id) {
            return AppUrl.API_URL + 'student-course-details/' + id;
        } else {
            return AppUrl.API_URL + 'student-course-details';
        }
    }

    static STUDENT_PAYMENT(): string {
        return AppUrl.API_URL + 'student-payment';
    }

    static STUDENT_QUALIFICATION_DETAILS(id?): string {
        if (id) {
            return AppUrl.API_URL + 'student-qualification/' + id;
        } else {
            return AppUrl.API_URL + 'student-qualification';
        }
    }

    static STUDENT_MORE_QUALIFICATION_DETAILS(id?): string {
        if (id) {
            return AppUrl.API_URL + 'student-more-qualification/' + id;
        } else {
            return AppUrl.API_URL + 'student-more-qualification';
        }
    }

    static STUDENT_COURSES(id?): string {
        if (id) {
            return AppUrl.API_URL + 'student-address/' + id;
        } else {
            return AppUrl.API_URL + 'student-address';
        }
    }

    static ABOUT_US(id?): string {
        if (id) {
            return AppUrl.API_URL + 'about-us/' + id;
        } else {
            return AppUrl.API_URL + 'about-us';
        }
    }

    static LANDING_PAGE_ABOUT_US(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'landing-page-about-us/' + id;
        }
    }

    static LANDING_PAGE_SLIDER(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'landing-page-slider/' + id;
        }
    }

    static LANDING_PAGE_COURSE(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'landing-page-course/' + id;
        }
    }

    static LANDING_PAGE_WHY_US(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'landing-page-why-us/' + id;
        }
    }

    static LANDING_PAGE_CONTACT_US(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'landing-page-contact-us/' + id;
        }
    }

    static APPLICATION_DETAIL(id?): string {
        if (id) {
            return AppUrl.API_URL + 'application/' + id;
        } else {
            return AppUrl.API_URL + 'application';
        }
    }

    static APPLICATION_STATUS(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'application-status/' + id;
        }
    }

    static UNIVERSITY_COURSE_CURRICULUM(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'university-course-curriculum/' + id;
        } else {
            return AppUrl.APP_URL + 'university-course-curriculum';
        }
    }
}
